// extracted by mini-css-extract-plugin
export var IconBlue = "icon-module--IconBlue--61400";
export var IconHeader = "icon-module--IconHeader--6599f";
export var IconNav = "icon-module--IconNav--39226";
export var IconRed = "icon-module--IconRed--a03b2";